export var SearchQueryParams;
(function (SearchQueryParams) {
    SearchQueryParams["q"] = "q";
    SearchQueryParams["p"] = "p";
    SearchQueryParams["e"] = "e";
    SearchQueryParams["s"] = "s";
    SearchQueryParams["pp"] = "pp";
    SearchQueryParams["topicId"] = "topicId";
    SearchQueryParams["topicName"] = "topicName";
    SearchQueryParams["meetingId"] = "meetingId";
    SearchQueryParams["meetingName"] = "meetingName";
    SearchQueryParams["refiners"] = "refiners";
    SearchQueryParams["oobRefiners"] = "oobRefiners";
    SearchQueryParams["customRefiners"] = "customRefiners";
    SearchQueryParams["wm"] = "wm";
})(SearchQueryParams || (SearchQueryParams = {}));
//# sourceMappingURL=SearchQueryParams.js.map